import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { PermissionNavigationItem } from '@core/constants/app-navigation.constants';

/** Renders site navigation entries with recursively nested flyout menus. */
@Component({
  selector: 'app-navigation',
  imports: [RouterLink, RouterLinkActive, NgTemplateOutlet],
  templateUrl: './navigation.html',
  styleUrl: './navigation.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationComponent {
  /** Navigation entries rendered as the site-specific menu. */
  readonly items = input<PermissionNavigationItem[]>([]);

  protected alignFlyout(event: Event): void {
    const item = event.currentTarget as HTMLElement | null;
    const submenu = item?.querySelector<HTMLElement>(':scope > .navigation-level');
    if (!item || !submenu) return;

    item.classList.remove('flyout-end');
    if (submenu.getBoundingClientRect().right > window.innerWidth) {
      item.classList.add('flyout-end');
    }
  }

  protected closeFlyout(event: Event): void {
    (event.currentTarget as HTMLElement | null)?.blur();
  }

  protected openNewWindow(event: Event, link: string | null): void {
    event.preventDefault();
    if (typeof window === 'undefined' || !link) return;
    
    // Open as a new window with specific dimensions (not a tab)
    window.open(
      link,
      'active-route-window',
      'directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1366,height=750,top=0,left=0'
    );
  }
}
